import { Order } from '../BookingsCalendarTypes';

const filterOrders = (unbookedOrders, query, selectedRegion) => {
    const filterOnRegion = (order: Order): boolean => {
        if (selectedRegion === '') {
            return true;
        }
        if (selectedRegion) {
            return order.orderAddress.regionId === selectedRegion.toString();
        }
    };

    const filterOnQuery = (order: Order): boolean => {
        if (query === '') {
            return true;
        }

        let hasMatch = false;

        if (order.createdAt.toLowerCase().includes(query)) {
            hasMatch = true;
        }

        if (order.orderCollectionNumber.toString().includes(query)) {
            hasMatch = true;
        }

        if (order.orderAddress.address.toLowerCase().includes(query)) {
            hasMatch = true;
        }

        if (order.orderAddress.city.toLowerCase().includes(query)) {
            hasMatch = true;
        }

        if (order.customer.brokerFirmName.toLowerCase().includes(query)) {
            hasMatch = true;
        }

        if (order.customer.agentName.toLowerCase().includes(query)) {
            hasMatch = true;
        }

        if ('express'.includes(query) && order.orderDeliveryProperties.isExpress) {
            hasMatch = true;
        }
        return hasMatch;
    };

    return unbookedOrders.filter(filterOnQuery).filter(filterOnRegion);
};

export default filterOrders;
